import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import axios from "axios";
import "../../assets/stylesheets/faq.css";
import Accordion from "./Accordion";
import Logo from "../../assets/image/logo.svg";

function Faq() {
  const { t, i18n } = useTranslation(["faq", "error"]);
  const [faqs, setFaqs] = useState([]);
  const [isShowIndex, setIsShowIndex] = useState(0);

  useEffect(() => {
    axios
        .get(`${process.env.REACT_APP_MY_API_KAY}/faqs`, {
          params: { language: i18n.language || "hy" },
        })
        .then((res) => {
          setFaqs(res.data);
        })
        .catch((error) => {
          console.error("Error fetching FAQs:", error);
          setFaqs([]);
        });
  }, [i18n.language]);

  return (
      <>
        <Helmet>
          <link
              rel="canonical"
              href={`https://sievn.am/${i18n.language}/${t("faq-url")}`}
          />
          <meta
              property="og:url"
              content={`https://sievn.am/${i18n.language}/${t("faq-url")}`}
          />
          <meta property="og:title" content={t("faqTitle")} />
          <meta property="og:site_name" content="sievn.am" />
          <meta property="og:description" content={t("faqDescribe")} />
          <meta property="og:image" content={Logo} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="description" content={t("faqDescribe")} />
          <title>{t("faqTitle")}</title>
        </Helmet>

        <section className="faq-page">
          <div className="main-container-faq">
            <div className="headings-faq">
              <h1 className="title-faq">
                <em>{t("faq")}</em>
              </h1>
            </div>
            <div className="accordion-container-faq">
              {faqs.length > 0 ? (
                  faqs.map((item, index) => (
                      <Accordion
                          key={index}
                          title={item.answer}
                          subTitle={item.question}
                          onClick={() => setIsShowIndex(index === isShowIndex ? null : index)}
                          isShow={index === isShowIndex}
                      />
                  ))
              ) : (
                  <div className="fallback-faq">
                    {t("noFaqsAvailable", { ns: "error" })}
                  </div>
              )}
            </div>
          </div>
        </section>
      </>
  );
}

export default Faq;